import { Button } from 'react-bootstrap';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { EyesPosition } from 'src/models/Session.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import getGradingResult from 'src/utils/getGradingResult';

interface RetakeActionButtonsProps {
  handleRetake: (position: EyesPosition) => void;
  handleCloseAnalyzingProgressModal: () => void;
}

const RetakeActionButtons = ({
  handleRetake,
  handleCloseAnalyzingProgressModal,
}: RetakeActionButtonsProps) => {
  const { session } = useRemoteBoundStore();

  const { isLeftEyeGradable, isRightEyeGradable } = getGradingResult(session);

  const isBothEyeUngradable = !isLeftEyeGradable && !isRightEyeGradable;

  const { tPages } = useUiTranslation();

  return (
    <>
      {session.graded && isBothEyeUngradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.BOTH);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {tPages('newExam.retake')}
        </Button>
      )}
      {session.graded && !isBothEyeUngradable && !isLeftEyeGradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.LEFT);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {tPages('newExam.retakeLeftEye')}
        </Button>
      )}

      {session.graded && !isBothEyeUngradable && !isRightEyeGradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.RIGHT);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {tPages('newExam.retakeRightEye')}
        </Button>
      )}
    </>
  );
};

export default RetakeActionButtons;
